<template>
  <component
    :is="tag"
    v-bind="$attrs"
    :type="type"
    class="button-icon"
    :class="[{ _reverse: reverse, 'u-clickable': isButton }, sizeClass]"
    @click="$emit('click')"
  >
    <transition namde="fade" mode="out-in">
      <span v-if="!!$slots.before" key="before" class="u-flex-shrink-0">
        <slot name="before" />
      </span>
      <span
        v-else-if="!!$slots.icon"
        class="
          button-icon__icon
          u-text-green-dark
          u-decor
          u-fill-deep-current
          u-stroke-deep-current
          u-flex-shrink-0
        "
      >
        <svg-inline tag="span">
          <slot name="icon" />
        </svg-inline>
      </span>
    </transition>
    <span v-if="!!$slots.default" class="button-icon__text font-semibold">
      <slot />
    </span>
  </component>
</template>

<script>
import SvgInline from "@/components/ui-kit/svg-inline/index.vue";

export default {
  components: {
    SvgInline,
  },
  inheritAttrs: false,
  props: {
    tag: {
      type: String,
      default: "button",
    },
    reverse: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: undefined,
      validator(size) {
        return ["", "sm", "md", "lg"].includes(size);
      },
    },
  },
  computed: {
    isButton() {
      return this.tag === "button";
    },
    type() {
      if (this.$attrs.type) {
        return this.$attrs.type;
      }

      if (this.isButton) {
        return "button";
      }

      return undefined;
    },
    sizeClass() {
      return this.size ? `_size-${this.size}` : "";
    },
  },
};
</script>

<style lang="scss" scoped>
$b: ".button-icon";

#{$b} {
  @include mixin.button-reset();
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: top;
  position: relative;

  &:disabled {
    pointer-events: none;
    opacity: 0.5;
  }

  &__text {
    display: block;
    text-align: left;
    transition: var.$transition-default;
  }

  &__icon {
    width: 20px;

    #{$b}._size-sm & {
      width: 16px;
    }

    #{$b}._size-md & {
      width: 22px;
    }

    #{$b}._size-lg & {
      width: 28px;
    }

    &:not(:only-child) {
      margin-right: 6px;

      #{$b}._reverse & {
        order: 1;
        margin-right: 0;
        margin-left: 6px;
      }

      #{$b}._icon-md & {
        //
      }

      #{$b}._icon-md._reverse & {
        margin-right: 0;
        // margin-left:
      }
    }
  }
}
</style>
